export default "__VITE_ASSET__C$sIu$Z1__"